import { requireAuth } from './auth';
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;

export async function postNewTTSRequest(payload) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = `${baseURL}/tts/RequestTTS`;
    const response = await fetch(url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
        body: JSON.stringify({
            params: {
                payload: payload
            }
        })
    });
    return response;
}

async function postTTSStreamingRequest(endpoint, payload) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = `${baseURL}/tts/${endpoint}`;
    const response = await fetch(url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
        body: JSON.stringify({
            params: {
                payload: payload
            }
        })
    });
    return response;
}

export async function postNewTTSStreamRequest(payload) {
    return postTTSStreamingRequest('RequestTTSStream', payload);
}

export async function postNewTTSChunkStreamRequest(payload) {
    return postTTSStreamingRequest('RequestTTSStreamChunk', payload);
}

export async function postNewTTSChunkStreamByVoiceRequest(payload) {
    return postTTSStreamingRequest('RequestTTSStreamChunkByVoice', payload);
}

export async function getTTSRequestByUploadId(uploadId) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/tts/GetTtsRequestByUploadId`);
    url.searchParams.append('uploadId', uploadId);
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    if (!response.ok) {
        throw new Error(`TTS status lookup failed: HTTP ${response.status}`);
    }
    return await response.json();
}

export async function getTTSRequest() {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = `${baseURL}/tts/GetTtsHistoryByUserId`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    console.log(data);
    return data;
}

export async function getModelsByUserId() {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = `${baseURL}/voices/GetModelsByUserId`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    console.log('[TTS Models API] response:', {
        status: response.status,
        ok: response.ok,
        rows: Array.isArray(data) ? data.map(model => model?.model_name) : data,
    });
    return data;
}

export async function getVoicesByUserId() {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = `${baseURL}/voices/GetVoicesByUserId`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    return data;
}

export async function getRecommendVoices(queryText) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/voices/RecommendVoices`);
    url.searchParams.append('queryText', queryText);
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('getRecommendVoices failed:', error);
        throw error;
    }
}

export async function patchRecommendVoicePlayed(voiceid) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/voices/RecommendVoicePlayed`);
    url.searchParams.append('voiceid', voiceid);
    url.searchParams.append('this_played_times', 1);
    try {
        const response = await fetch(url, {
            method: "PATCH",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('patchRecommendVoicePlayed failed:', error);
        throw error;
    }
}

export async function UploadUserVoice(wavData, voiceName, model, tag, instructText) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
    };

    const url_ = `${baseURL}/voices/UploadUserVoice`;

    const payload = {
        wavData: wavData,
        voiceName: voiceName,
        model: model,
        tag: tag,
        instructText: instructText,
    };
    try {
        const response = await fetch(url_, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        });
        return response
    } catch (error) {
        console.error('UploadUserVoice failed:', error);
        throw error;
    }
}

export async function getUserVoicesByUserId() {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = `${baseURL}/voices/GetUserVoicesByUserId`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    return data;
}

export async function DeleteUserVoice(voiceId) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
    };

    const url_ = `${baseURL}/voices/DeleteUserVoice`;

    const params = {
        voiceId: voiceId
    };

    try {
        const response = await axios.delete(url_, { headers, params });
        return response
    } catch (error) {
        console.error('DeleteUserVoice failed:', error);
        throw error;
    }
}


export async function patchUserVoiceName(voiceId, newName) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
    };

    const url_ = `${baseURL}/voices/RenameUserVoiceFile`;

    const params = {
        voiceId: voiceId,
        newVoiceName: newName
    };

    try {
        const response = await axios.patch(url_, null, { headers, params });
        return response
    } catch (error) {
        console.error('PatchUserVoiceName failed:', error);
        throw error;
    }
}


export async function patchUserVoiceTag(voiceId, newTag) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
    };

    const url_ = `${baseURL}/voices/RenameUserVoiceTag`;

    const params = {
        voiceId: voiceId,
        newVoiceTag: newTag
    };

    try {
        const response = await axios.patch(url_, null, { headers, params });
        return response
    } catch (error) {
        console.error('patchUserVoiceTag failed:', error);
        throw error;
    }
}
export async function patchUserVoiceInstructText(voiceId, newInstructText) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
    };

    const url_ = `${baseURL}/voices/RenameUserVoiceInstructText`;

    const params = {
        voiceId: voiceId,
        newVoiceInstruct: newInstructText
    };

    try {
        const response = await axios.patch(url_, null, { headers, params });
        return response
    } catch (error) {
        console.error('PatchUserVoiceInstructText failed:', error);
        throw error;
    }
}
